import { ApiService } from '../common/serviceBase';
import { URL_NOVA_API } from '../common/apiUrl';

export class RelversoesService {
    constructor() {
        this.service = new ApiService(`${URL_NOVA_API}/relatorios`);
    }

    async getAll(relm_id) {
        const response = await this.service.get(`/relmodelos/${relm_id}/relversoes`);
        return response.data;
    }

    async create(relm_id, data) {
        const response = await this.service.post(`/relmodelos/${relm_id}/relversoes`, data);
        return response.data;
    }

    async remove(relm_id, relv_id) {
        const response = await this.service.delete(`/relmodelos/${relm_id}/relversoes/${relv_id}`);
        return response;
    }
}